import { apiClient } from './client'
import type { ApiResponse } from './client'
import type { DynamicsConnectionStatus, DynamicsAuthInitiateResult } from '@/types/dynamics'

export const dynamicsApi = {
    /**
     * Get OAuth authorization URL to open in a popup. The Dataverse environment URL is required
     * up front because the Entra scope is per-org ("{environmentUrl}/.default"), so it's passed
     * as a query param the backend validates and echoes into the authorize request.
     */
    initiate: (environmentUrl: string): Promise<ApiResponse<DynamicsAuthInitiateResult>> =>
        apiClient.get(`/api/Auth/Dynamics/Initiate?environmentUrl=${encodeURIComponent(environmentUrl)}`),

    /** Check Dynamics connection status for a company */
    getStatus: (clientCompanyId: string): Promise<ApiResponse<DynamicsConnectionStatus>> =>
        apiClient.get(`/api/ClientCompanies/${clientCompanyId}/Integrations/Dynamics/Status`),

    /** Disconnect Dynamics for a company */
    disconnect: (clientCompanyId: string): Promise<ApiResponse<void>> =>
        apiClient.post(`/api/ClientCompanies/${clientCompanyId}/Integrations/Dynamics/Disconnect`, {}),
}
